import AboutComponent from "../components/AboutUs2";
import Establishment from "../components/Establishment";
import Facts from "../components/Facts";
import PageHeader from "../components/PageHeader";
import Team from "../components/Team";
import TeamExpanded from "../components/TeamExpanded";

const About = () => {
  return (
    <>
      <PageHeader title="About" />
      <Establishment/>
      <AboutComponent />
      <Facts />
      <TeamExpanded />
    </>
  );
};

export default About;
